"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BinaryDataParser = void 0;
/**
 * Base binary data parser.
 */
class BinaryDataParser {
    constructor(data) {
        this.LITTLE_ENDIAN = true;
        this.offset = 0;
        this.data = new DataView(data);
    }
    get buffer() {
        return this.data.buffer;
    }
    getUint8() {
        return this.data.getUint8(this.offset++);
    }
    getUint16() {
        const uint16 = this.data.getUint16(this.offset, this.LITTLE_ENDIAN);
        this.offset += 2;
        return uint16;
    }
    getUint32() {
        const uint32 = this.data.getUint32(this.offset, this.LITTLE_ENDIAN);
        this.offset += 4;
        return uint32;
    }
    getUint64() {
        const lo = this.data.getUint32(this.offset, this.LITTLE_ENDIAN);
        const hi = this.data.getUint32(this.offset + 4, this.LITTLE_ENDIAN);
        this.offset += 8;
        return ((hi * (1 << 32)) + lo);
    }
    getFloat32() {
        const float32 = this.data.getFloat32(this.offset, this.LITTLE_ENDIAN);
        this.offset += 4;
        return float32;
    }
    getUint32Array(bytes) {
        const result = new Uint32Array(this.buffer, this.offset, bytes);
        this.offset += bytes;
        return result;
    }
    skipBytes(bytes) {
        this.offset += bytes;
    }
    readSphere(additionalRadius = false) {
        return {
            x: this.getFloat32(),
            y: this.getFloat32(),
            z: this.getFloat32(),
            radius: this.getFloat32(),
            tightRadius: !additionalRadius ? 0 : this.getFloat32()
        };
    }
}
exports.BinaryDataParser = BinaryDataParser;
